export default "__VITE_ASSET__2N0IH8aQ__"